// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   Form,
//   Button,
//   Table,
//   Pagination,
//   Badge,
//   Modal,
//   InputGroup,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import {
//   FaFilter as FaFilterIcon,
//   FaUser,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaCheck,
//   FaTimes,
// } from "react-icons/fa";

// import "../SupportReport/AdminReports.css";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// // reasonable status set for full building
// const FB_STATUS_OPTIONS = [
//   "pending",
//   "in_review",
//   "visit_scheduled",
//   "quote_shared",
//   "completed",
//   "cancelled",
// ];

// // date helpers (same style as AdminReports)
// const fmtDate = (d) => {
//   if (!d) return "-";
//   const dt = new Date(d);
//   if (isNaN(dt)) return "-";
//   const dd = String(dt.getDate()).padStart(2, "0");
//   const m = [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ][dt.getMonth()];
//   const yyyy = dt.getFullYear();
//   return `${dd}-${m}-${yyyy}`;
// };

// const fmtTime = (d) => {
//   if (!d) return "-";
//   const dt = new Date(d);
//   if (isNaN(dt)) return "-";
//   return dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
// };

// // map to existing badge styles from AdminReports.css
// const badgeForStatus = (s) => {
//   const key = (s || "pending").toLowerCase();
//   switch (key) {
//     case "pending":
//       return "adminReports-badge adminReports-badge-open";
//     case "in_review":
//       return "adminReports-badge adminReports-badge-in_review";
//     case "visit_scheduled":
//     case "quote_shared":
//       return "adminReports-badge adminReports-badge-awaiting_party_response";
//     case "completed":
//       return "adminReports-badge adminReports-badge-resolved";
//     case "cancelled":
//       return "adminReports-badge adminReports-badge-dismissed";
//     default:
//       return "adminReports-badge adminReports-badge-open";
//   }
// };

// const statusLabel = (s) => (s || "").replaceAll("_", " ") || "-";

// const getPageItems = (total, current, maxButtons = 7) => {
//   const pages = [];
//   pages.push(1);
//   const siblings = Math.floor((maxButtons - 3) / 2);
//   let start = Math.max(2, current - siblings);
//   let end = Math.min(total - 1, current + siblings);

//   if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//   if (current >= total - (siblings + 1))
//     start = Math.max(2, total - (maxButtons - 2));

//   if (start > 2) pages.push("start-ellipsis");
//   for (let i = start; i <= end; i++) pages.push(i);
//   if (end < total - 1) pages.push("end-ellipsis");
//   if (total > 1) pages.push(total);
//   return pages;
// };

// const AdminFullBuilding = () => {
//   const [rows, setRows] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     sortBy: "created_at",
//     sortDir: "DESC",
//     search: "",
//     status: "",
//   });
//   const [loading, setLoading] = useState(true);

//   // filters
//   const [search, setSearch] = useState("");
//   const [status, setStatus] = useState("All");
//   const [page, setPage] = useState(1);

//   // modals
//   const [selected, setSelected] = useState(null);
//   const [showView, setShowView] = useState(false);
//   const [showEdit, setShowEdit] = useState(false);
//   const [editStatus, setEditStatus] = useState("pending");
//   const [savingEdit, setSavingEdit] = useState(false);

//   const sortBy = "created_at";
//   const sortDir = "DESC";

//   const fetchFullBuilding = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       const { data } = await axios.get(`${URL}/admin/full-building`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page,
//           limit: DEFAULT_LIMIT,
//           search,
//           status: status === "All" ? "" : status,
//           sortBy,
//           sortDir,
//         },
//       });

//       setRows(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) {
//         setMeta(data.meta);
//       } else {
//         setMeta((m) => ({
//           ...m,
//           page,
//           limit: DEFAULT_LIMIT,
//           total: Array.isArray(data) ? data.length : 0,
//           totalPages: 1,
//           sortBy,
//           sortDir,
//           search,
//           status: status === "All" ? "" : status,
//         }));
//       }
//     } catch (e) {
//       console.error("Failed to load full building requests:", e);
//       setRows([]);
//       setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchFullBuilding();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page, search, status]);

//   // open/close view
//   const handleOpenView = (r) => {
//     setSelected(r);
//     setShowView(true);
//     document.body.style.overflow = "hidden";
//   };
//   const handleCloseView = () => {
//     setShowView(false);
//     setSelected(null);
//     document.body.style.overflow = "auto";
//   };

//   // open/close edit
//   const handleOpenEdit = (r) => {
//     setSelected(r);
//     setEditStatus(r.status || "pending");
//     setShowEdit(true);
//   };
//   const handleCloseEdit = () => {
//     setShowEdit(false);
//     setSelected(null);
//   };

//   const submitEdit = async () => {
//     if (!selected) return;
//     try {
//       setSavingEdit(true);
//       const token = localStorage.getItem("token");
//       await axios.patch(
//         `${URL}/admin/full-building/${selected.Id}`,
//         { status: editStatus },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setShowEdit(false);
//       setSelected(null);
//       await fetchFullBuilding();
//       alert("Request updated.");
//     } catch (e) {
//       console.error(e);
//       alert(
//         e?.response?.data?.message ||
//           e?.response?.data?.error ||
//           "Failed to update request"
//       );
//     } finally {
//       setSavingEdit(false);
//     }
//   };

//   const totalPages = meta.totalPages || 1;

//   const customerName = (r) => {
//     if (!r.User) return "-";
//     const fn = r.User.FirstName || "";
//     const ln = r.User.LastName || "";
//     const full = `${fn} ${ln}`.trim();
//     return full || "-";
//   };

//   return (
//     <Container fluid className="adminReports-container">
//       <Card className="adminReports-card">
//         <Card.Body>
//           <Card.Header className="adminReports-header">
//             <h4 className="adminReports-title">Full Building Requests</h4>
//           </Card.Header>

//           {/* Filters */}
//           <Row className="align-items-center g-2 mb-3">
//             <Col lg={6}>
//               <InputGroup>
//                 <Form.Control
//                   placeholder="Search by order / user / mobile / location…"
//                   value={search}
//                   onChange={(e) => {
//                     setSearch(e.target.value);
//                     setPage(1);
//                   }}
//                   className="adminReports-search"
//                 />
//                 <InputGroup.Text className="adminReports-search-ico">
//                   <FaFilterIcon />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col lg={3}>
//               <Form.Select
//                 value={status}
//                 onChange={(e) => {
//                   setStatus(e.target.value);
//                   setPage(1);
//                 }}
//                 className="adminReports-filter"
//               >
//                 <option value="All">All Status</option>
//                 {FB_STATUS_OPTIONS.map((s) => (
//                   <option key={s} value={s}>
//                     {s.replaceAll("_", " ")}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//             <Col lg={3} className="text-end">
//               <div className="small text-muted">
//                 Total: <strong>{meta.total}</strong> requests
//               </div>
//             </Col>
//           </Row>

//           {/* Table */}
//           <Table
//             striped
//             bordered
//             hover
//             responsive
//             className="adminReports-table"
//           >
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order</th>
//                 <th>Customer</th>
//                 <th>Service</th>
//                 <th>Status</th>
//                 <th>Preferred Visit</th>
//                 <th>Created</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!loading &&
//                 rows.map((r, idx) => (
//                   <tr key={r.Id}>
//                     <td>{(meta.page - 1) * meta.limit + idx + 1}</td>

//                     {/* Order */}
//                     <td>
//                       <div className="adminReports-cell-main">
//                         <span className="adminReports-strong">
//                           {r.order_number}
//                         </span>
//                       </div>
//                       <div className="adminReports-muted">
//                         {r.location || "-"}
//                       </div>
//                     </td>

//                     {/* Customer (Name + mobile) */}
//                     <td>
//                       <div className="adminReports-cell-main">
//                         <span className="adminReports-strong">
//                           {customerName(r)}
//                         </span>
//                       </div>
//                       <div className="adminReports-muted">
//                         {r.User?.mobile || "-"}
//                       </div>
//                     </td>

//                     {/* Service summary */}
//                     <td>
//                       <div className="adminReports-cell-main">
//                         <span>{r.service_type || "-"}</span>
//                       </div>
//                       <div className="adminReports-muted">
//                         {r.building_type
//                           ? `${r.building_type}${
//                               r.floors ? ` • ${r.floors} floors` : ""
//                             }`
//                           : r.floors
//                           ? `${r.floors} floors`
//                           : "-"}
//                       </div>
//                     </td>

//                     {/* Status */}
//                     <td>
//                       <Badge className={badgeForStatus(r.status)}>
//                         {statusLabel(r.status)}
//                       </Badge>
//                     </td>

//                     {/* Preferred visit */}
//                     <td>
//                       <div className="adminReports-datetime">
//                         <div className="adminReports-date">
//                           Date:{" "}
//                           {r.preferred_date ? fmtDate(r.preferred_date) : "-"}
//                         </div>
//                         <div className="adminReports-time">
//                           Time: {r.preferred_time || "-"}
//                         </div>
//                       </div>
//                     </td>

//                     {/* Created */}
//                     <td>
//                       <div className="adminReports-datetime">
//                         <div className="adminReports-date">
//                           Date: {fmtDate(r.created_at)}
//                         </div>
//                         <div className="adminReports-time">
//                           Time: {fmtTime(r.created_at)}
//                         </div>
//                       </div>
//                     </td>

//                     {/* Actions */}
//                     <td>
//                       <div className="adminReports-actions">
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => handleOpenView(r)}
//                           title="View"
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-edit"
//                           size="sm"
//                           className="adminReports-action-btn"
//                           onClick={() => handleOpenEdit(r)}
//                           title="Edit"
//                         >
//                           <FaCheck size={14} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}

//               {!loading && rows.length === 0 && (
//                 <tr>
//                   <td colSpan={8} style={{ textAlign: "center" }}>
//                     No full building requests found.
//                   </td>
//                 </tr>
//               )}

//               {loading && (
//                 <tr>
//                   <td colSpan={8} style={{ textAlign: "center" }}>
//                     Loading…
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination */}
//           <Pagination className="mt-3">
//             <Pagination.First
//               onClick={() => setPage(1)}
//               disabled={meta.page === 1}
//             />
//             <Pagination.Prev
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               disabled={meta.page === 1}
//             />
//             {getPageItems(totalPages, meta.page).map((item, i) =>
//               item === "start-ellipsis" || item === "end-ellipsis" ? (
//                 <Pagination.Ellipsis key={item + i} disabled />
//               ) : (
//                 <Pagination.Item
//                   key={item}
//                   active={item === meta.page}
//                   onClick={() => setPage(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               )
//             )}
//             <Pagination.Next
//               onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//               disabled={meta.page === meta.totalPages}
//             />
//             <Pagination.Last
//               onClick={() => setPage(meta.totalPages)}
//               disabled={meta.page === meta.totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* ===== View Modal (same style as AdminReports) ===== */}
//       {showView && selected && (
//         <div className="adminReports-modal-backdrop">
//           <div className="adminReports-modal">
//             <div className="adminReports-modal-header">
//               <button
//                 className="adminReports-modal-close"
//                 onClick={handleCloseView}
//               >
//                 <FaTimes size={20} />
//               </button>
//               <div>
//                 <h2 className="adminReports-modal-title">
//                   Full Building • {selected.order_number}
//                 </h2>
//                 <p className="adminReports-modal-subtitle">
//                   {selected.service_type || "Full Building Service"}
//                   {selected.building_type
//                     ? ` • ${selected.building_type}`
//                     : ""}
//                   {selected.floors ? ` • ${selected.floors} floors` : ""}
//                 </p>
//               </div>
//             </div>

//             <div className="adminReports-modal-body">
//               {/* Summary badges */}
//               <div className="adminReports-summary">
//                 <Badge className={badgeForStatus(selected.status)}>
//                   {statusLabel(selected.status)}
//                 </Badge>
//                 <span className="adminReports-chip">
//                   <FaUser style={{ marginRight: 4 }} />
//                   {customerName(selected)}{" "}
//                   {selected.User?.mobile ? `• ${selected.User.mobile}` : ""}
//                 </span>
//                 <span className="adminReports-chip">
//                   Date: {fmtDate(selected.created_at)}
//                 </span>
//                 <span className="adminReports-chip">
//                   Time: {fmtTime(selected.created_at)}
//                 </span>
//               </div>

//               {/* Request Info */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Request Information</h3>
//                 <div className="adminReports-two-col">
//                   <div>
//                     <p className="adminReports-detail-text">Order Number</p>
//                     <p className="adminReports-detail-value">
//                       {selected.order_number}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Status</p>
//                     <p className="adminReports-detail-value">
//                       {statusLabel(selected.status)}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminReports-two-col" style={{ marginTop: 8 }}>
//                   <div>
//                     <p className="adminReports-detail-text">Service Type</p>
//                     <p className="adminReports-detail-value">
//                       {selected.service_type || "-"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Building Type</p>
//                     <p className="adminReports-detail-value">
//                       {selected.building_type || "-"}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminReports-two-col" style={{ marginTop: 8 }}>
//                   <div>
//                     <p className="adminReports-detail-text">Floors</p>
//                     <p className="adminReports-detail-value">
//                       {selected.floors || "-"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Budget Range</p>
//                     <p className="adminReports-detail-value">
//                       {selected.budget_range || "-"}
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Customer Details */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">
//                   <FaUser className="adminReports-title-icon user" />
//                   Customer
//                 </h3>
//                 <div className="adminReports-info-row">
//                   <FaUser className="adminReports-icon" />
//                   <div>
//                     <p className="adminReports-detail-text">Name</p>
//                     <p className="adminReports-detail-value">
//                       {customerName(selected)}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminReports-info-row">
//                   <FaPhone className="adminReports-icon" />
//                   <div>
//                     <p className="adminReports-detail-text">Mobile</p>
//                     <p className="adminReports-detail-value">
//                       {selected.User?.mobile || "-"}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminReports-info-row">
//                   <FaMapMarkerAlt className="adminReports-icon" />
//                   <div>
//                     <p className="adminReports-detail-text">City / Area / Address</p>
//                     <p className="adminReports-detail-value">
//                       {[
//                         selected.User?.city,
//                         selected.User?.area,
//                         selected.User?.Address,
//                       ]
//                         .filter(Boolean)
//                         .join(" — ") || "-"}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminReports-info-row">
//                   <FaMapMarkerAlt className="adminReports-icon" />
//                   <div>
//                     <p className="adminReports-detail-text">Project Location</p>
//                     <p className="adminReports-detail-value">
//                       {selected.location || "-"}
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Schedule */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Preferred Schedule</h3>
//                 <div className="adminReports-two-col">
//                   <div>
//                     <p className="adminReports-detail-text">Preferred Date</p>
//                     <p className="adminReports-detail-value">
//                       {selected.preferred_date
//                         ? fmtDate(selected.preferred_date)
//                         : "-"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="adminReports-detail-text">Preferred Time</p>
//                     <p className="adminReports-detail-value">
//                       {selected.preferred_time || "-"}
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Project Details */}
//               <div className="adminReports-detail-card">
//                 <h3 className="adminReports-detail-title">Project Details</h3>
//                 <p className="adminReports-detail-text">Description</p>
//                 <p className="adminReports-detail-value">
//                   {selected.details || "-"}
//                 </p>
//               </div>

//               <div className="adminReports-modal-footer">
//                 <div className="adminReports-footer-buttons">
//                   <button
//                     className="adminReports-footer-btn adminReports-footer-btn-close"
//                     onClick={handleCloseView}
//                   >
//                     <FaCheck /> Close
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ===== Edit Modal ===== */}
//       <Modal
//         show={showEdit}
//         onHide={handleCloseEdit}
//         centered
//         backdrop="static"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Full Building Request</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selected && (
//             <>
//               <p className="mb-2">
//                 <strong>Order:</strong> {selected.order_number}
//               </p>
//               <p className="mb-3 text-muted">
//                 {customerName(selected)}{" "}
//                 {selected.User?.mobile ? `• ${selected.User.mobile}` : ""}
//               </p>
//               <Form.Group className="mb-3">
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select
//                   value={editStatus}
//                   onChange={(e) => setEditStatus(e.target.value)}
//                 >
//                   {FB_STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>
//                       {s.replaceAll("_", " ")}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//               <div className="small text-muted">
//                 Use <strong>in_review</strong> when team is evaluating,{" "}
//                 <strong>visit_scheduled</strong> for confirmed site visit,{" "}
//                 <strong>quote_shared</strong> when quotation sent, and{" "}
//                 <strong>completed</strong> when project is closed.
//               </div>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="light" onClick={handleCloseEdit} disabled={savingEdit}>
//             Cancel
//           </Button>
//           <Button variant="success" onClick={submitEdit} disabled={savingEdit}>
//             {savingEdit ? "Saving…" : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default AdminFullBuilding;





// ***** Upper code is okay, updated with Auth Protect (2-Dec-2025) ***** //
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  Pagination,
  Badge,
  Modal,
  InputGroup,
} from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import {
  FaFilter as FaFilterIcon,
  FaUser,
  FaPhone,
  FaMapMarkerAlt,
  FaCheck,
  FaTimes,
} from "react-icons/fa";

import "../SupportReport/AdminReports.css";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;

/* ========= Admin Auth Helpers ========= */
const getAdminToken = () => localStorage.getItem("adminToken") || "";
const getAdminAuthHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// reasonable status set for full building
const FB_STATUS_OPTIONS = [
  "pending",
  "in_review",
  "visit_scheduled",
  "quote_shared",
  "completed",
  "cancelled",
];

// date helpers (same style as AdminReports)
const fmtDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  const dd = String(dt.getDate()).padStart(2, "0");
  const m = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][dt.getMonth()];
  const yyyy = dt.getFullYear();
  return `${dd}-${m}-${yyyy}`;
};

const fmtTime = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  return dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

// map to existing badge styles from AdminReports.css
const badgeForStatus = (s) => {
  const key = (s || "pending").toLowerCase();
  switch (key) {
    case "pending":
      return "adminReports-badge adminReports-badge-open";
    case "in_review":
      return "adminReports-badge adminReports-badge-in_review";
    case "visit_scheduled":
    case "quote_shared":
      return "adminReports-badge adminReports-badge-awaiting_party_response";
    case "completed":
      return "adminReports-badge adminReports-badge-resolved";
    case "cancelled":
      return "adminReports-badge adminReports-badge-dismissed";
    default:
      return "adminReports-badge adminReports-badge-open";
  }
};

const statusLabel = (s) => (s || "").replaceAll("_", " ") || "-";

const getPageItems = (total, current, maxButtons = 7) => {
  const pages = [];
  pages.push(1);
  const siblings = Math.floor((maxButtons - 3) / 2);
  let start = Math.max(2, current - siblings);
  let end = Math.min(total - 1, current + siblings);

  if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
  if (current >= total - (siblings + 1))
    start = Math.max(2, total - (maxButtons - 2));

  if (start > 2) pages.push("start-ellipsis");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push("end-ellipsis");
  if (total > 1) pages.push(total);
  return pages;
};

const AdminFullBuilding = () => {
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
    sortBy: "created_at",
    sortDir: "DESC",
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(true);

  // filters
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [page, setPage] = useState(1);

  // modals
  const [selected, setSelected] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editStatus, setEditStatus] = useState("pending");
  const [savingEdit, setSavingEdit] = useState(false);

  const sortBy = "created_at";
  const sortDir = "DESC";

  const fetchFullBuilding = async () => {
    try {
      setLoading(true);

      const headers = getAdminAuthHeaders();
      if (!headers.Authorization) {
        console.warn("No admin token found for AdminFullBuilding.");
        setRows([]);
        setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
        return;
      }

      const { data } = await axios.get(`${URL}/admin/full-building`, {
        headers,
        params: {
          page,
          limit: DEFAULT_LIMIT,
          search,
          status: status === "All" ? "" : status,
          sortBy,
          sortDir,
        },
      });

      setRows(Array.isArray(data?.data) ? data.data : []);
      if (data?.meta) {
        setMeta(data.meta);
      } else {
        setMeta((m) => ({
          ...m,
          page,
          limit: DEFAULT_LIMIT,
          total: Array.isArray(data) ? data.length : 0,
          totalPages: 1,
          sortBy,
          sortDir,
          search,
          status: status === "All" ? "" : status,
        }));
      }
    } catch (e) {
      console.error("Failed to load full building requests:", e);
      setRows([]);
      setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFullBuilding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, status]);

  // open/close view
  const handleOpenView = (r) => {
    setSelected(r);
    setShowView(true);
    document.body.style.overflow = "hidden";
  };
  const handleCloseView = () => {
    setShowView(false);
    setSelected(null);
    document.body.style.overflow = "auto";
  };

  // open/close edit
  const handleOpenEdit = (r) => {
    setSelected(r);
    setEditStatus(r.status || "pending");
    setShowEdit(true);
  };
  const handleCloseEdit = () => {
    setShowEdit(false);
    setSelected(null);
  };

  const submitEdit = async () => {
    if (!selected) return;
    try {
      setSavingEdit(true);

      const headers = getAdminAuthHeaders();
      if (!headers.Authorization) {
        alert("Missing admin authentication token.");
        return;
      }

      await axios.patch(
        `${URL}/admin/full-building/${selected.Id}`,
        { status: editStatus },
        { headers }
      );
      setShowEdit(false);
      setSelected(null);
      await fetchFullBuilding();
      alert("Request updated.");
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          "Failed to update request"
      );
    } finally {
      setSavingEdit(false);
    }
  };

  const totalPages = meta.totalPages || 1;

  const customerName = (r) => {
    if (!r.User) return "-";
    const fn = r.User.FirstName || "";
    const ln = r.User.LastName || "";
    const full = `${fn} ${ln}`.trim();
    return full || "-";
  };

  return (
    <Container fluid className="adminReports-container">
      <Card className="adminReports-card">
        <Card.Body>
          <Card.Header className="adminReports-header">
            <h4 className="adminReports-title">Full Building Requests</h4>
          </Card.Header>

          {/* Filters */}
          <Row className="align-items-center g-2 mb-3">
            <Col lg={6}>
              <InputGroup>
                <Form.Control
                  placeholder="Search by order / user / mobile / location…"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                  className="adminReports-search"
                />
                <InputGroup.Text className="adminReports-search-ico">
                  <FaFilterIcon />
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col lg={3}>
              <Form.Select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
                className="adminReports-filter"
              >
                <option value="All">All Status</option>
                {FB_STATUS_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s.replaceAll("_", " ")}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col lg={3} className="text-end">
              <div className="small text-muted">
                Total: <strong>{meta.total}</strong> requests
              </div>
            </Col>
          </Row>

          {/* Table */}
          <Table
            striped
            bordered
            hover
            responsive
            className="adminReports-table"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Order</th>
                <th>Customer</th>
                <th>Service</th>
                <th>Status</th>
                <th>Preferred Visit</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                rows.map((r, idx) => (
                  <tr key={r.Id}>
                    <td>{(meta.page - 1) * meta.limit + idx + 1}</td>

                    {/* Order */}
                    <td>
                      <div className="adminReports-cell-main">
                        <span className="adminReports-strong">
                          {r.order_number}
                        </span>
                      </div>
                      <div className="adminReports-muted">
                        {r.location || "-"}
                      </div>
                    </td>

                    {/* Customer (Name + mobile) */}
                    <td>
                      <div className="adminReports-cell-main">
                        <span className="adminReports-strong">
                          {customerName(r)}
                        </span>
                      </div>
                      <div className="adminReports-muted">
                        {r.User?.mobile || "-"}
                      </div>
                    </td>

                    {/* Service summary */}
                    <td>
                      <div className="adminReports-cell-main">
                        <span>{r.service_type || "-"}</span>
                      </div>
                      <div className="adminReports-muted">
                        {r.building_type
                          ? `${r.building_type}${
                              r.floors ? ` • ${r.floors} floors` : ""
                            }`
                          : r.floors
                          ? `${r.floors} floors`
                          : "-"}
                      </div>
                    </td>

                    {/* Status */}
                    <td>
                      <Badge className={badgeForStatus(r.status)}>
                        {statusLabel(r.status)}
                      </Badge>
                    </td>

                    {/* Preferred visit */}
                    <td>
                      <div className="adminReports-datetime">
                        <div className="adminReports-date">
                          Date:{" "}
                          {r.preferred_date ? fmtDate(r.preferred_date) : "-"}
                        </div>
                        <div className="adminReports-time">
                          Time: {r.preferred_time || "-"}
                        </div>
                      </div>
                    </td>

                    {/* Created */}
                    <td>
                      <div className="adminReports-datetime">
                        <div className="adminReports-date">
                          Date: {fmtDate(r.created_at)}
                        </div>
                        <div className="adminReports-time">
                          Time: {fmtTime(r.created_at)}
                        </div>
                      </div>
                    </td>

                    {/* Actions */}
                    <td>
                      <div className="adminReports-actions">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="adminReports-action-btn"
                          onClick={() => handleOpenView(r)}
                          title="View"
                        >
                          <BsEye size={16} />
                        </Button>
                        <Button
                          variant="outline-edit"
                          size="sm"
                          className="adminReports-action-btn"
                          onClick={() => handleOpenEdit(r)}
                          title="Edit"
                        >
                          <FaCheck size={14} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}

              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    No full building requests found.
                  </td>
                </tr>
              )}

              {loading && (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    Loading…
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          <Pagination className="mt-3">
            <Pagination.First
              onClick={() => setPage(1)}
              disabled={meta.page === 1}
            />
            <Pagination.Prev
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={meta.page === 1}
            />
            {getPageItems(totalPages, meta.page).map((item, i) =>
              item === "start-ellipsis" || item === "end-ellipsis" ? (
                <Pagination.Ellipsis key={item + i} disabled />
              ) : (
                <Pagination.Item
                  key={item}
                  active={item === meta.page}
                  onClick={() => setPage(item)}
                >
                  {item}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={meta.page === meta.totalPages}
            />
            <Pagination.Last
              onClick={() => setPage(meta.totalPages)}
              disabled={meta.page === meta.totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {/* ===== View Modal (same style as AdminReports) ===== */}
      {showView && selected && (
        <div className="adminReports-modal-backdrop">
          <div className="adminReports-modal">
            <div className="adminReports-modal-header">
              <button
                className="adminReports-modal-close"
                onClick={handleCloseView}
              >
                <FaTimes size={20} />
              </button>
              <div>
                <h2 className="adminReports-modal-title">
                  Full Building • {selected.order_number}
                </h2>
                <p className="adminReports-modal-subtitle">
                  {selected.service_type || "Full Building Service"}
                  {selected.building_type
                    ? ` • ${selected.building_type}`
                    : ""}
                  {selected.floors ? ` • ${selected.floors} floors` : ""}
                </p>
              </div>
            </div>

            <div className="adminReports-modal-body">
              {/* Summary badges */}
              <div className="adminReports-summary">
                <Badge className={badgeForStatus(selected.status)}>
                  {statusLabel(selected.status)}
                </Badge>
                <span className="adminReports-chip">
                  <FaUser style={{ marginRight: 4 }} />
                  {customerName(selected)}{" "}
                  {selected.User?.mobile ? `• ${selected.User.mobile}` : ""}
                </span>
                <span className="adminReports-chip">
                  Date: {fmtDate(selected.created_at)}
                </span>
                <span className="adminReports-chip">
                  Time: {fmtTime(selected.created_at)}
                </span>
              </div>

              {/* Request Info */}
              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">
                  Request Information
                </h3>
                <div className="adminReports-two-col">
                  <div>
                    <p className="adminReports-detail-text">Order Number</p>
                    <p className="adminReports-detail-value">
                      {selected.order_number}
                    </p>
                  </div>
                  <div>
                    <p className="adminReports-detail-text">Status</p>
                    <p className="adminReports-detail-value">
                      {statusLabel(selected.status)}
                    </p>
                  </div>
                </div>
                <div className="adminReports-two-col" style={{ marginTop: 8 }}>
                  <div>
                    <p className="adminReports-detail-text">Service Type</p>
                    <p className="adminReports-detail-value">
                      {selected.service_type || "-"}
                    </p>
                  </div>
                  <div>
                    <p className="adminReports-detail-text">Building Type</p>
                    <p className="adminReports-detail-value">
                      {selected.building_type || "-"}
                    </p>
                  </div>
                </div>
                <div className="adminReports-two-col" style={{ marginTop: 8 }}>
                  <div>
                    <p className="adminReports-detail-text">Floors</p>
                    <p className="adminReports-detail-value">
                      {selected.floors || "-"}
                    </p>
                  </div>
                  <div>
                    <p className="adminReports-detail-text">Budget Range</p>
                    <p className="adminReports-detail-value">
                      {selected.budget_range || "-"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Customer Details */}
              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">
                  <FaUser className="adminReports-title-icon user" />
                  Customer
                </h3>
                <div className="adminReports-info-row">
                  <FaUser className="adminReports-icon" />
                  <div>
                    <p className="adminReports-detail-text">Name</p>
                    <p className="adminReports-detail-value">
                      {customerName(selected)}
                    </p>
                  </div>
                </div>
                <div className="adminReports-info-row">
                  <FaPhone className="adminReports-icon" />
                  <div>
                    <p className="adminReports-detail-text">Mobile</p>
                    <p className="adminReports-detail-value">
                      {selected.User?.mobile || "-"}
                    </p>
                  </div>
                </div>
                <div className="adminReports-info-row">
                  <FaMapMarkerAlt className="adminReports-icon" />
                  <div>
                    <p className="adminReports-detail-text">
                      City / Area / Address
                    </p>
                    <p className="adminReports-detail-value">
                      {[
                        selected.User?.city,
                        selected.User?.area,
                        selected.User?.Address,
                      ]
                        .filter(Boolean)
                        .join(" — ") || "-"}
                    </p>
                  </div>
                </div>
                <div className="adminReports-info-row">
                  <FaMapMarkerAlt className="adminReports-icon" />
                  <div>
                    <p className="adminReports-detail-text">
                      Project Location
                    </p>
                    <p className="adminReports-detail-value">
                      {selected.location || "-"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Schedule */}
              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">
                  Preferred Schedule
                </h3>
                <div className="adminReports-two-col">
                  <div>
                    <p className="adminReports-detail-text">Preferred Date</p>
                    <p className="adminReports-detail-value">
                      {selected.preferred_date
                        ? fmtDate(selected.preferred_date)
                        : "-"}
                    </p>
                  </div>
                  <div>
                    <p className="adminReports-detail-text">Preferred Time</p>
                    <p className="adminReports-detail-value">
                      {selected.preferred_time || "-"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Project Details */}
              <div className="adminReports-detail-card">
                <h3 className="adminReports-detail-title">Project Details</h3>
                <p className="adminReports-detail-text">Description</p>
                <p className="adminReports-detail-value">
                  {selected.details || "-"}
                </p>
              </div>

              <div className="adminReports-modal-footer">
                <div className="adminReports-footer-buttons">
                  <button
                    className="adminReports-footer-btn adminReports-footer-btn-close"
                    onClick={handleCloseView}
                  >
                    <FaCheck /> Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== Edit Modal ===== */}
      <Modal
        show={showEdit}
        onHide={handleCloseEdit}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Full Building Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <p className="mb-2">
                <strong>Order:</strong> {selected.order_number}
              </p>
              <p className="mb-3 text-muted">
                {customerName(selected)}{" "}
                {selected.User?.mobile ? `• ${selected.User.mobile}` : ""}
              </p>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                >
                  {FB_STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s.replaceAll("_", " ")}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <div className="small text-muted">
                Use <strong>in_review</strong> when team is evaluating,{" "}
                <strong>visit_scheduled</strong> for confirmed site visit,{" "}
                <strong>quote_shared</strong> when quotation sent, and{" "}
                <strong>completed</strong> when project is closed.
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={handleCloseEdit}
            disabled={savingEdit}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={submitEdit}
            disabled={savingEdit}
          >
            {savingEdit ? "Saving…" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminFullBuilding;
